export const PHONE_INPUT_TEST_IDS = {
  phone: "message-input-phone",
  regionSelector: "region-selector",
};
